module.exports = __webpack_public_path__ + "assets/img/new.9fdbcb1a.png";